export async function importModule() {
  return await import(/* webpackChunkName: "chartjs" */ 'chart.js');
}